( () => {
  const ENTER = 1;
  const EXIT = 0;
  const TARGET_SELECTOR = 'body';

  let isScrolled = false;
  let rafId = null;
  let pendingY = 0;
  let targetEl = null;

  const addScrolled = () => {
    if ( !targetEl ) return;
    targetEl.classList.add( 'scrolled' );
    isScrolled = true;
  };

  const removeScrolled = () => {
    if ( !targetEl ) return;
    targetEl.classList.remove( 'scrolled' );
    isScrolled = false;
  };

  const updateScrolledState = ( y ) => {
    if ( !isScrolled && y > ENTER ) {
      addScrolled();
    } else if ( isScrolled && y <= EXIT ) {
      removeScrolled();
    }
  };

  const flushScroll = () => {
    updateScrolledState( pendingY );
    rafId = null;
  };

  const onScroll = () => {
    pendingY = window.scrollY || 0;
    if ( rafId ) return;
    rafId = requestAnimationFrame( flushScroll );
  };

  document.addEventListener( 'DOMContentLoaded', () => {
    targetEl = document.querySelector( TARGET_SELECTOR );
    if ( !targetEl ) return;

    onScroll(); // handle page load at mid-scroll
    window.addEventListener( 'scroll', onScroll, { passive: true } );
  } );
} )();
